<template>
  <div ref="playerDiv" class="player" :style="{height: `${playerHeight}px`}">
    <div class="player-wrapper">
      <video
        v-if="showPlayer"
        ref="video"
        :controls="controls"
        class="video-js vjs-default-skin"
        :data-setup="settings"
      >
          <!-- <div class="control">
            <div class="progress"></div>
            <div class="actions pa-1 d-flex">
              <div clas="play-pause">
                <v-btn
                  color="primary"
                  class="control-icon" icon dark
                >
                  <iconControlPlay />
                </v-btn>
                <v-btn
                  color="primary"
                  class="control-icon" icon dark
                >
                  <iconControlPause />
                </v-btn>
                <v-btn
                  color="primary"
                  class="control-icon" icon dark
                >
                  <iconControlReplay />
                </v-btn>
              </div>
              <div class="volume">
                <div class="mute">
                  <v-btn
                    color="primary"
                    class="control-icon" icon dark
                  >
                    <iconControlMute />
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="control-icon" icon dark
                  >
                    <iconControlMuteOn />
                  </v-btn>
                </div>
                <div class="volume-progress"></div>
              </div>
              <div class="times">
                {{time}} / 2:33
              </div>
              <v-spacer/>
              <div class="full-screen">
                <v-btn
                  color="primary"
                  class="control-icon" icon dark
                >
                  <iconControlFull />
                </v-btn>
                <v-btn
                  color="primary"
                  class="control-icon" icon dark
                >
                  <iconControlFullOn />
                </v-btn>
              </div>
            </div>
          </div> -->
      </video>
    </div>
  </div>
</template>

<script>
import throttle from 'lodash/throttle';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import '@/utils/videoYT';
// import iconControlFullOn from '@/static/img/icon-control-full-on.svg';
// import iconControlFull from '@/static/img/icon-control-full.svg';
// import iconControlMuteOn from '@/static/img/icon-control-mute-on.svg';
// import iconControlMute from '@/static/img/icon-control-mute.svg';
// import iconControlPause from '@/static/img/icon-control-pause.svg';
// import iconControlPlay from '@/static/img/icon-control-play.svg';
// import iconControlReplay from '@/static/img/icon-control-replay.svg';

export default {
  components: {
    // iconControlFullOn,
    // iconControlFull,
    // iconControlMuteOn,
    // iconControlMute,
    // iconControlPause,
    // iconControlPlay,
    // iconControlReplay,
  },
  props: {
    videoId: {
      type: String,
      require: true,
    },

    points: {
      type: Array,
      default: () => [],
    },

    controls: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      player: null,
      time: '00:00',
      playerWidth: 800,
      innerPoints: [],
      showPlayer: true,
    };
  },

  computed: {
    settings () {
      return JSON.stringify({
        techOrder: ['youtube'],
        sources: [{ type: 'video/youtube', src: `https://www.youtube.com/watch?v=${this.videoId}` }],
        youtube: { customControls: this.controls, actionText: this.$t('base.videoActionText'), ytControls: 0, modestbranding: 0, disablekb: 0, showinfo: 0, rel: 0, loop: 1, playsinline: 0 },
      });
    },

    playerHeight () {
      return Math.floor(this.playerWidth * 56.25 / 100);
    },
  },

  watch: {
    videoId () {
      this.showPlayer = false;

      this.$nextTick(() => { this.showPlayer = true; });
    },
  },

  methods: {
    resizeHandler: throttle(function () {
      this.playerWidth = this.$refs.playerDiv.clientWidth;
    }, 500),

    processHandler: throttle(function () {
      // console.log(this.player.currentTime());

      this.innerPoints.forEach(point => {
        if (this.player.currentTime() >= point.time && !point.done) {
          point.done = true;
          point.cb();
        }
      });
    }, 2000),
  },

  mounted () {
    this.innerPoints = [...this.points];
    this.playerWidth = this.$refs.playerDiv.clientWidth;
    window.addEventListener('resize', this.resizeHandler);
    const _this = this;
    videojs(this.$refs.video).ready(function () {
      _this.player = this;
      _this.player.on('timeupdate', _this.processHandler);
      _this.player.on('ended', () => _this.$emit('ended'));
    });
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.resizeHandler);
  },
};
</script>

<style lang="scss">
.vjs-fullscreen-toggle {
  position: absolute;
  bottom: 71px;
  right: 10px;
  width: 40px;
  height: 40px;
  z-index: 5;
  background-color: rgb(250, 80, 123);
  background-size: 24px;
  background-position: 50%;
  border-radius: 3px;
  cursor: pointer;
  transition:opacity 0.3s;
  opacity: 0;
  display: none;
}

.vjs-youtube.vjs-has-started .vjs-fullscreen-toggle {
  display: block;
}

.vjs-youtube.vjs-ended .vjs-action-button,
.vjs-youtube.vjs-ended .vjs-fullscreen-toggle,
.vjs-youtube.vjs-paused .vjs-action-button,
.vjs-youtube.vjs-paused .vjs-fullscreen-toggle,
.vjs-youtube.vjs-user-active .vjs-action-button,
.vjs-youtube.vjs-user-active .vjs-fullscreen-toggle {
  opacity: 1;
}

.vjs-youtube.vjs-fullscreen .vjs-fullscreen-toggle {
  bottom: 20px;
  right: 20px;
}

.vjs-poster-blocker {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: 50%;
  z-index: 3;
}

.vjs-action-button {
  position: absolute;
  bottom: 50%;
  right: 50%;
  transform: translate(50%, 50%);
  width: 70px;
  height: 50px;
  z-index: 5;
  background-color: rgb(250, 80, 123);
  background-size: 24px;
  background-position: 50%;
  border-radius: 3px;
  cursor: pointer;
  opacity: 0;
  transition:opacity 0.3s;
  font-size: 0;
}

.vjs-action-button.play {
  width: auto;
  height: auto;
  padding: 20px 44px;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  letter-spacing: -.4px;
  border: 4px solid #fff;
  border-radius: 48px;
  z-index: 5;
  background-color: rgb(250, 80, 123);
  transform: translate(50%, 50%) scale(1);
  -webkit-animation: scale 2s ease-out infinite;
  animation: scale 2s ease-out infinite;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    padding: 12px 25px;
    font-size: 14px;
  }
}

.vjs-action-button.pause {
  display: none;
}

.vjs-action-button.end {
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CgogPGc+CiAgPHRpdGxlPmJhY2tncm91bmQ8L3RpdGxlPgogIDxyZWN0IGZpbGw9Im5vbmUiIGlkPSJjYW52YXNfYmFja2dyb3VuZCIgaGVpZ2h0PSI0MDIiIHdpZHRoPSI1ODIiIHk9Ii0xIiB4PSItMSIvPgogPC9nPgogPGc+CiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPgogIDxwYXRoIGZpbGw9IiNmZmZmZmYiIGlkPSJzdmdfMSIgZD0ibTI4LDE2Yy0xLjIxOSwwIC0xLjc5NywwLjg1OSAtMiwxLjc2NmMtMC43MzEsMy4yNjQgLTMuODMzLDguMjM0IC0xMCw4LjIzNGMtNS41MjMsMCAtMTAsLTQuNDc4IC0xMCwtMTBzNC40NzcsLTEwIDEwLC0xMGMyLjI0LDAgNC4yOTUsMC43NTMgNS45NiwybC0xLjk2LDBjLTEuMTA0LDAgLTIsMC44OTYgLTIsMnMwLjg5NiwyIDIsMmw2LDBjMS4xMDQsMCAyLC0wLjg5NiAyLC0ybDAsLTZjMCwtMS4xMDQgLTAuODk2LC0yIC0yLC0ycy0yLDAuODk2IC0yLDJsMCwwLjUxOGMtMi4yNjcsLTEuNTg2IC01LjAyMywtMi41MTggLTgsLTIuNTE4Yy03LjczMiwwIC0xNCw2LjI2OCAtMTQsMTRzNi4yNjgsMTQgMTQsMTRjOS45NzksMCAxNCwtOS41IDE0LC0xMS44NzVjMCwtMS40NTMgLTEuMDYyLC0yLjEyNSAtMiwtMi4xMjV6Ii8+CiA8L2c+Cjwvc3ZnPg==');
}

.vjs-youtube.vjs-fullscreen .vjs-poster-blocker {
  background-size: cover;
}

.vjs-youtube.vjs-paused .vjs-poster-blocker,
.vjs-youtube.vjs-playing .vjs-poster-blocker {
  transition:opacity 1.5s;
  opacity: 0;
}
// .vjs-youtube.vjs-scrubbing .vjs-poster-blocker,
.vjs-youtube.vjs-ended .vjs-poster-blocker {
  transition:opacity 0s;
  opacity: 1;
}

.vjs-youtube-mobile .vjs-big-play-button { display: none; }
.vjs-poster-blocker::before {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  content: "";
  background: rgba(0,0,0,.6);
  z-index: 4;
  transition:opacity 1s;
}

.vjs-youtube.vjs-playing .vjs-poster-blocker::before {
  content: unset;
}

.video-js .vjs-control-bar {
  bottom: 61px;
  z-index: 3;
}

@-webkit-keyframes scale {
    0% {
        transform: translate(50%, 50%) scale(1);
    }

    50% {
        transform: translate(50%, 50%) scale(1.08);
    }

    to {
        transform: translate(50%, 50%) scale(1);
    }
}

@keyframes scale {
    0% {
        transform: translate(50%, 50%) scale(1);
    }

    50% {
        transform: translate(50%, 50%) scale(1.08);
    }

    to {
        transform: translate(50%, 50%) scale(1);
    }
}
</style>

<style lang="scss" scoped>
 .video-js {
  width: 100%;
  height: 100%;
  position: absolute;
  top: -61px;
  left: 0;
}

.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.player {
  max-width: 900px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #000;
  margin: auto;

  .player-wrapper {
    max-width: 100%;
    height: 0;
    position: relative;
    overflow: hidden;
    padding-bottom: calc(56.25% + 122px);
  }
}

.control {
  width: 100%;
  background: rgb(0 0 0 / 40%);
  position: absolute;
  bottom: 120px;
  z-index: 3;
  color: white;
}

.control-icon {
  // width: 44px;
  // height: 48px;
  cursor: pointer;
}
</style>
